import React, { createElement } from 'react';
import Style from './index.module.scss';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip'
import Chip from 'Chip';

export interface Support_1_Props {
    supportChip: TYPE_Chip;
    style?: object;
}

const Support_1: React.FC<Support_1_Props> = (props) => {
    const { supportChip, style } = props;

    const structData = useChip(supportChip);
    const chipComponentData = formatChip(supportChip)

    return (
        <Chip {...chipComponentData}>
            <div className={Style.wrap} style={style}>
                {structData && Array.isArray(structData) && structData.length
                    ? structData.map((item) => {
                        const { title, list } = item;

                        return (
                            <div className={Style.section} key={title}>
                                <div className={Style.sectionTitle}>{title}</div>
                                <div className={Style.sectionList}>
                                    {list && Array.isArray(list) && list.length
                                        ? list.map((item) => {
                                            const { imgUrl, link } = item;

                                            return (
                                                <div className={Style.icon} key={imgUrl}>
                                                    {link ? (
                                                        <a href={link} target="_blank">
                                                            <img src={imgUrl} alt="" />
                                                        </a>
                                                    ) : (
                                                        <img src={imgUrl} alt="" />
                                                    )}
                                                </div>
                                            );
                                        })
                                        : null}
                                </div>
                            </div>
                        );
                    })
                    : null}
                <Mask visible={!supportChip.id} zIndex={3}>示例结构化碎片—{supportChip.default.id}</Mask>
            </div>
        </Chip>
    );
};

export default Support_1;
